import React from 'react'

function log(key: string, error: any) {
  // eslint-disable-next-line
  console.log('error in local storage key:', key)
  // eslint-disable-next-line
  console.error(error)
}

export function useLocalStorage(key: string, initialValue) {
  const getValue = () => {
    try {
      if (typeof window !== 'undefined') {
        const item = window.localStorage.getItem(key)
        return item ? JSON.parse(item) : initialValue
      }
      return initialValue
    } catch (error) {
      log(key, error)
      return initialValue
    }
  }

  const [storedValue, setStoredValue] = React.useState(getValue())

  const setValue = (value) => {
    try {
      setStoredValue(value)
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(key, JSON.stringify(value))
        window.dispatchEvent(new Event('storageMutate'))
      }
    } catch (error) {
      log(key, error)
    }
  }

  const removeValue = () => {
    try {
      setStoredValue(null)
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem(key)
        window.dispatchEvent(new Event('storageMutate'))
      }
    } catch (error) {
      log(key, error)
    }
  }

  return { data: storedValue, set: setValue, remove: removeValue }
}
